import React from 'react';
import { Link } from 'react-router-dom';
import CurrentUser from '../CurrentUser';

const avatarStyles = {
  display: "inline-block",
  fontSize: "1em",
  width: "2.5em",
  height: "2.5em",
  lineHeight: "2.5em",
  textAlign: "center",
  borderRadius: "50%",
  background: "#3e5467",
  verticalAlign: "middle",
  color: "white",
  border: "1px solid #4c677f"
}

const UserMenu = () => (
  <CurrentUser
    render={user =>
      user ? (
        <li className="user-box">
          <figure>
            <span style={avatarStyles}>{user.firstName[0].toUpperCase()}{user.lastName[0].toUpperCase()}</span>
            <figcaption>{user.firstName} {user.lastName}</figcaption>
          </figure>
          <div className="user-controls">
            <Link to="/profile" title="Profile" data-icon="&#xe919;">Profile</Link>
            <Link to="/logout" title="Logout" data-icon="&#xe90c;">Logout</Link>
          </div>
        </li>) : null
    }
  />
);

export default UserMenu;



// WEBPACK FOOTER //
// ./src/components/shared/UserMenu.js